"use strict";

const elementList = document.querySelectorAll(".article__faq-q");

elementList.forEach((element) => {
  element.addEventListener("click", () => {
    const current = document.getElementsByClassName(
      "article__faq-entry __open"
    );
    current[0].classList.remove("__open");
    element.parentElement.classList.add("__open");
  });
});
